import { defineRecipe } from "@chakra-ui/react";

export const linkRecipe = defineRecipe({
  variants: {
    variant: {
      empty: {
        underline: "none",
      },
      underline: {
        color: "text.fg_info",
      },
    },
  },
});
